import { graphql } from "@/lib/gql/__generated__";

export const HotelI18n_DesignPage_Query = graphql(`
	query HotelI18n_DesignPage($hotelID: ID!, $lang: LangCode!) {
		hotelI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			companyID
			hotelID
			name
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
	}
`);
